<!--
  SecaoPadrao — wrapper de `<section>` com container interno e padding padrão.
  Padroniza a estrutura `<section class="ds-section"><div class="ds-container">...`.

  Props:
    - id         : id da seção (útil p/ âncoras de scroll, ex: id="formulario")
    - variante   : 'default' | 'alt' (fundo secundário) | 'hero' | 'compact'
    - container  : 'default' (1100px) | 'sm' (780px) | 'none' (sem container)
    - as         : tag HTML (default 'section'; pode virar 'header', 'main', 'footer')

  Uso:
    <SecaoPadrao id="faq" variante="alt">
      ...
    </SecaoPadrao>
-->
<template>
  <component :is="as" :id="id" :class="['ds-section', variantClass]">
    <div v-if="container !== 'none'" :class="containerClass">
      <slot />
    </div>
    <slot v-else />
  </component>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  id: { type: String, default: null },
  variante: {
    type: String,
    default: 'default',
    validator: (v) => ['default', 'alt', 'hero', 'compact'].includes(v)
  },
  container: {
    type: String,
    default: 'default',
    validator: (v) => ['default', 'sm', 'none'].includes(v)
  },
  as: { type: String, default: 'section' }
})

const variantClass = computed(() => {
  if (props.variante === 'alt') return 'ds-section--alt'
  if (props.variante === 'hero') return 'ds-section--hero'
  if (props.variante === 'compact') return 'ds-section--compact'
  return null
})

const containerClass = computed(() =>
  props.container === 'sm' ? 'ds-container-sm' : 'ds-container'
)
</script>
